import { cn } from '../../utils/cn'
import { useAccount } from '../../contexts/authContext'

import type { Children } from '../../types'

function CheckInWrapper({ children }: Children) {
  const account = useAccount()
  const checkInSettings = account.account.checkInSettings

  return (
    <div
      style={{
        '--image-url': `url(${checkInSettings?.background?.image})`,
      }}
      className={cn('ion-padding h-full', {
        'bg-[image:var(--image-url)] bg-cover':
          checkInSettings?.background?.image,
      })}
    >
      {children}
    </div>
  )
}

export { CheckInWrapper }
